import type { ContactFormState } from "@/types/contact.types";

export const EMPTY_CONTACT_FORM: ContactFormState = {
  name: "",
  email: "",
  phone: "",
  category: "",
  budget: "",
  message: "",
  marketing_opt_in: false,
};

export const CONTACT_CATEGORIES = [
  "Web Development",
  "Mobile App Development",
  "UI/UX Design",
  "Custom Software Development",
  "Digital Marketing",
  "IT Consultancy",
  "Other",
];

export const CONTACT_BUDGETS = [
  "1k",
  "2k–5k",
  "5k–10k",
  "10k–20k",
  "30k–50k",
  "50k–100k",
  "100k+",
];
